import { Building2, Globe, TrendingUp, Shield } from "lucide-react";

const COLLAB_IMG = "https://static.prod-images.emergentagent.com/jobs/b5a08d36-4e1b-4658-ac05-a4f9da84b1e7/images/7215243ec945d3c804151d3e198aee2917ead1d3a4bdd859c221115686433d31.png";

const highlights = [
  { icon: Globe, label: "Global Reach", value: "Multi-jurisdiction access across asset classes" },
  { icon: TrendingUp, label: "Proven Strategies", value: "Equities, credit, and alternative investments" },
  { icon: Shield, label: "Regulated", value: "Registered in Singapore" },
  { icon: Building2, label: "InCred Group", value: "Part of a diversified financial services platform" },
];

const AboutUs = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A6670] mb-4 font-body" data-testid="about-overline">
            About Us
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-heading" data-testid="about-title">
            Who We Are
          </h2>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Text content */}
          <div className="lg:col-span-7 space-y-6">
            <p className="text-base leading-relaxed text-slate-600 font-body" data-testid="about-description-1">
              InCred Global Asset Management is the Asset Management Division of InCred Global Wealth Pte Ltd, a Licensed Fund Management company in Singapore. We run diversified portfolios across public equities, Private Equity and Global credit.
            </p>

            {/* Highlights grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6">
              {highlights.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-4 p-4 border border-slate-200 rounded-sm hover:border-[#4A6670] transition-colors duration-300"
                  data-testid={`about-highlight-${idx}`}
                >
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-[#F8FAFC] rounded-sm">
                    <item.icon className="h-5 w-5 text-[#E87722]" />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-slate-900 font-heading">{item.label}</p>
                    <p className="text-xs text-slate-500 mt-1 font-body">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                src={COLLAB_IMG}
                alt="InCred Global team"
                className="w-full h-auto rounded-sm shadow-sm"
                data-testid="about-image"
              />
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#E87722] rounded-sm opacity-10" />
              <div className="absolute -top-4 -right-4 w-32 h-32 border-2 border-[#4A6670] rounded-sm opacity-20" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
